@for (menuItem of visibleItems(); track menuItem.label) {
  <a
    class="navigation-menu__item"
    routerLinkActive="navigation-menu__item_active"
    [routerLink]="menuItem.link"
  >
    {{ menuItem.label }}
  </a>
}
